module.exports = __webpack_public_path__ + "static/media/YGY-Logo-Icon.b60529ad.svg";